import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs'
import { switchMap, map, tap } from 'rxjs/operators';

@Injectable()
export class HTTPCallsService {
  constructor(private httpClient: HttpClient) { }

  getThingData(pageNo: number) {
    let query = {
      pageNo: pageNo,
      size: 50
    };
    return this.httpClient.get(
      "https://dev.cogcons.com/api/synchronization/thingsDataSync?pageNo=" +
      query.pageNo +
      "&size=" +
      query.size
    );
  }
  mqttPublish(topic: string, payload: string, clientId) {
    let body = {
      topic: topic,
      payload: payload,
      retain: false,
      clientId: clientId
    };
    console.log(body);
    return this.httpClient.post(
      "https://dev.cogcons.com/api/users/dashboardMqttData",
      body
    );
  }

  getProfileIcon(phonenumber) {
    return this.httpClient.get("https://dev.cogcons.com/api/users/profile_pic/" + phonenumber,
      { responseType: 'blob' })
      .pipe(
        switchMap(response => this.readFile(response))
      );
  }

  private readFile(blob: Blob): Observable<string> {
    return Observable.create(obs => {
      const reader = new FileReader();

      reader.onerror = err => obs.error(err);
      reader.onabort = err => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();

      return reader.readAsDataURL(blob);
    });
  }
}
